import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Sidebarpo from "./Sidebarpo";



const PoReports = () => {
  const [poReports, setPoReports] = useState([]);

  useEffect(() => {
    axios.get('http://localhost:8000/api/po/reports')
      .then(res => setPoReports(res.data))
      .catch(err => console.error(err));
  }, []);

  return (
    <div className='row'>
          <div className="custom-2-5">

      <Sidebarpo />
      </div>
    <div className="custom-9-5 dashboardsclooer p-4">
      <h2 className="text-xl font-bold mb-4">PO Reports</h2>

      <table className="w-full border-collapse border">
        <thead>
          <tr className="bg-gray-200">
            <th className="border p-2">PO Number</th>
            <th className="border p-2">Customer</th>
            <th className="border p-2">Date</th>
            <th className="border p-2">Total</th>
            <th className="border p-2">Status</th>
          </tr>
        </thead>
        <tbody>
          {poReports.map((report) => (
            <tr key={report.id}>
              <td className="border p-2">{report.po_number}</td>
              <td className="border p-2">{report.customer_name}</td>
              <td className="border p-2">{report.date}</td>
              <td className="border p-2">₹{report.total}</td>
              <td className="border p-2">{report.status}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    </div>
  );
};

export default PoReports;
